import React from 'react';
import classNames from 'classnames';
import { favoritePlayerService } from 'general/js/services';
import {
    DEVICE_TYPE_MOBILE,
    DEVICE_TYPE_MOBILE_WIDE,
    DEVICE_TYPE_TABLET,
} from 'general/js/app';
import { CountryFlag } from 'project/country-flag';
import { LazyImage } from 'project/lazy-image';
import FavoritePlayerButton from 'components/favorite-player-button';
import { livePlayer } from 'components/live-player';
import {
    renderSitecoreData,
} from '../actions/renderData';

import LeaderboardCellPlayerExtra from './leaderboard-cell-player-extra';
import { LEADERBOARD_SCORECARD_TITLE } from '../../../live-player/js/enums';

const LeaderboardCellPlayerBasic = ({
    deviceTypeByViewport,
    player,
    ...rest
}) => {
    const renderNameComponent = () => {
        const playerSD = player.sitecoreData;

        if (!playerSD) return null;

        let firstName = playerSD.firstName;

        if (deviceTypeByViewport === DEVICE_TYPE_MOBILE ||
            deviceTypeByViewport === DEVICE_TYPE_MOBILE_WIDE ||
            deviceTypeByViewport === DEVICE_TYPE_TABLET) {
            firstName = firstName.charAt(0);
        }

        const fullnameCss = classNames({
            //'is-long': playerSD.lastName.length > 10,
            'is-lengthy': playerSD.lastName.length > 12,
        });

        return (
            <div className={`leaderboard__cell-player-fullname ${fullnameCss}`}>
                <div className={'leaderboard__cell-player-lastname'}>
                    {playerSD.lastName}
                </div>
                {
                    firstName &&
                    <span className="leaderboard__cell-player-separator">,</span>
                }
                <div className={'leaderboard__cell-player-firstname'}>
                    {firstName}
                </div>
                {
                    playerSD.isAmateur &&
                    <span className="leaderboard__cell-player-amateur">(a)</span>
                }
            </div>
        );
    };

    const favouriteTheme = {};

    if (favoritePlayerService.isFavourite(player.id.toString())) {
        favouriteTheme.isWhite = true;
    } else {
        favouriteTheme.isDark = true;
    }

    return (
        <div className="leaderboard__cell-player-basic">
            <div className="leaderboard__cell-player-basic-col-1">
                <div className="leaderboard__cell-player-favorite-button-wrapper">
                    <FavoritePlayerButton
                        playerId={player.id.toString()}
                        theme={favouriteTheme}
                    />
                </div>
                <button
                    className="leaderboard__cell-player-wrap"
                    type="button"
                    onClick={() => livePlayer.show(player.id, LEADERBOARD_SCORECARD_TITLE + player.sitecoreData.firstName + ' ' + player.sitecoreData.lastName)}
                >
                    <CountryFlag
                        childCss={'leaderboard__cell-player-flag'}
                        image={renderSitecoreData(player, 'countryFlagSrc')}
                        title={renderSitecoreData(player, 'country')}
                    />
                    {renderNameComponent()}
                    {
                        player.sitecoreData &&
                        player.sitecoreData.sponsorLogoSrc &&
                        <div className="leaderboard__cell-player-logo">
                            <LazyImage image={player.sitecoreData.sponsorLogoSrc}/>
                        </div>
                    }
                </button>
            </div>
            <LeaderboardCellPlayerExtra {...rest} player={player} />
        </div>
    );
};

export default LeaderboardCellPlayerBasic;
